export default {
  state: {
    default: {
      id: 0,
      competence: '',
      region: '',
      city: '',
      statusId: 0,
      supplyId: 1,
      scopeId: 0,
      userId: 0,
      instituitionId: 0,
      exposedChildren: "0",
      currentMonthBalance: "0",
      currentMonthInput: "0",
      currentMonthOutput: true,
      distributed: "0",
      rearranged: "0",
      total: "0",
      finalBalance: "0",
      observation: "",
      childrenServed: "0",
      childrenExposed: 0,
      neededNextMonth: true,
      quantityRequested: "0",
    },
    solicitationFormulaData: {}
  },

  getters: {
    getSolicitationFormulaDefaultData(state){
      return state.default;
    },

    getSolicitationFormulaData(state) {
      return state.solicitationFormulaData;
    },
  },

  mutations: {
    setSolicitationFormuladaData(state, data) {
      state.solicitationFormulaData = data;
    },
  },

  actions: {
    changeSolicitationFormuladaData(context, data) {
      context.commit("setSolicitationFormuladaData", data);
    },
  },
};
